/* eslint-disable @typescript-eslint/no-unused-vars */
import { IconButton, List, Modal, Stack, Text, getTheme } from '@fluentui/react';
import LinkAttachmentModalBox from 'features/LinkAttachmentModalBox/LinkAttachmentModalBox';
import { IvicosColors } from 'kits/colorKit';
import IvicosStrings from 'kits/language/stringKit';
import React from 'react';

interface IAttachmentCreationModalViewProps {
    isOpen?: boolean;
    onDismiss?: Function;
    createAttachment: (addOnName: string, isPinned: boolean, optionalRef?: string | undefined) => Promise<void>;
    addOns: {
        id: string;
        type: string;
        attributes: {
            urlTemplate: string;
            iconUrl: string;
            displayName: string;
            description: string;
        };
        relationships: {};
    }[];
    translation: (attachmentName: string, attachmentDescription: string) => string[];
    setToggleLinkAttachmentModalBox: any;
    setLinkAttachmentItemId: any;
    linkAttachmentItemIsPinned: boolean;
}

const AttachmentCreationModalView: React.FC<IAttachmentCreationModalViewProps> = (props) => {
    const { isOpen, onDismiss, createAttachment, addOns, translation, setToggleLinkAttachmentModalBox, setLinkAttachmentItemId, linkAttachmentItemIsPinned } =
        props;

    const theme = getTheme();

    return (
        <Modal isOpen={isOpen}>
            <Stack horizontal style={{ padding: 16 }} verticalAlign="center" horizontalAlign="space-between">
                <Text variant="large" style={{ fontWeight: 'bold' }}>
                    {IvicosStrings.chooseAttachmentTypeTitle}
                </Text>
                <IconButton
                    iconProps={{ iconName: 'clear' }}
                    onClick={() => {
                        onDismiss && onDismiss();
                    }}
                />
            </Stack>
            <LinkAttachmentModalBox />;
        </Modal>
    );
};

export default AttachmentCreationModalView;
